import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BaseComponent } from 'src/app/base/base.component';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';


@Component({
  selector: 'app-organization-settings',
  templateUrl: './organization-settings.component.html',
  styleUrls: ['./organization-settings.component.css'],
  standalone: false
})
export class OrganizationSettingsComponent extends BaseComponent {

  /* ================= TABS ================= */

  activeTab: 'ftp' | 'db' | 'api' = 'ftp';

  
  selectTab(tab: 'ftp' | 'db' | 'api') {
    this.activeTab = tab;
  }

  /* ================= CONSTRUCTOR ================= */

  constructor(
    matDialog: MatDialog,
    errorLogger: ErrorReportingService
  ) {
    super(errorLogger, matDialog);
  }
}
